import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CloseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CloseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.1344 19.9999C18.9128 19.9999 18.6913 19.9154 18.5221 19.7462L4.25422 5.47888C3.91591 5.14058 3.91591 4.59253 4.25422 4.25423C4.59252 3.91592 5.14057 3.91592 5.47887 4.25423L19.7468 18.5215C20.0851 18.8599 20.0851 19.4079 19.7468 19.7462C19.5776 19.9154 19.356 19.9999 19.1344 19.9999Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.86654 19.9999C4.64496 19.9999 4.42336 19.9154 4.25422 19.7462C3.91591 19.4079 3.91591 18.8598 4.25422 18.5215L18.5221 4.25422C18.8604 3.91591 19.4085 3.91591 19.7468 4.25422C20.0851 4.59252 20.0851 5.14057 19.7468 5.47887L5.47887 19.7462C5.30973 19.9153 5.08812 19.9999 4.86654 19.9999Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CloseIcon;
